import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { DivisionsTableDefinitionZod } from '../tables';

type Arguments = {
    userId: string;
};

export const schemaDivisionResolver_GetByLeaderId = DivisionsTableDefinitionZod.nullable();

export type SchemaDivisionResolver_GetByLeaderId = z.infer<typeof schemaDivisionResolver_GetByLeaderId>;

export type DivisionResolver_GetByLeaderId = Resolver<Arguments, SchemaDivisionResolver_GetByLeaderId>;
